import React from 'react';
import cn from 'classnames';

import { formatValue } from './helpers/format-value';
import { getFlag } from './helpers/get-flag';
import { normalizeValue } from './helpers/normalize-value';

interface Input {
  isValid?: boolean;
  name: string;
  onChange: (arg: string) => void;
  placeholder: string;
  style?: React.CSSProperties;
  type?: React.HTMLInputTypeAttribute;
  value: string;
}

const Input = ({
  isValid = true,
  onChange,
  placeholder,
  style,
  type = 'text',
  value,
}: Input) => {
  const flag = getFlag(value, type);
  const htmlValue = formatValue(value, type);

  return (
    <div
      className={cn('whatcrm-widget-input', {
        'whatcrm-widget-input_error': !isValid,
      })}
      style={style}
    >
      {flag && <span className="whatcrm-widget-input__flag">{flag}</span>}

      <input
        className="whatcrm-widget-input__field"
        onChange={e => onChange(normalizeValue(e.target.value, type))}
        placeholder={placeholder}
        type={type}
        value={htmlValue}
      />
    </div>
  );
};

export default Input;
